export default __webpack_public_path__ + "static/insta-icon-156b9197de7d5dc93ce33d06a946467b.svg";